import Vue from 'vue'
import Vuex from 'vuex'
import authHandler from './modules/auth-handler'
import signupHandler from './modules/signup-handler'
import forgotPasswordHandler from './modules/forgot-password-handler'
import assetHandler from './modules/asset-handler'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authHandler,
    signupHandler,
    forgotPasswordHandler,
    assetHandler
  },
  state: {
    forEmailVerification: true,
    forAdminApproval: false,
    ApiculusEnv: JSON.parse(localStorage.getItem('ApiculusEnv')) || {},
    passwordRegex: /^((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*-]))[0-9a-zA-Z!@#$%&*-]{8,16}$/
  }
})
